import { creditCardsService } from '@afterpaytouch/portal-api/consumer/account/creditcards'

export const {
  useInitiateNewMutation,
  useConfirmNewMutation,
  endpoints: { confirmNew, initiateNew },
} = creditCardsService
